import { useState, useEffect } from "react";
import {
  HubConnectionBuilder,
  HubConnection,
  HttpTransportType,
} from "@microsoft/signalr";
import { RootState } from "@/store/reducers";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { baseURL } from "@/services/api";
import { addEditMessages } from "@/store/chat";
import { MessageModel } from "@/types/chat";

export const useChatHub = () => {
  const [connection, setConnection] = useState<HubConnection>();
  const authToken = useSelector((state: RootState) => state.login.authToken);
  const dispatch = useDispatch();

  useEffect(() => {
    const connection = new HubConnectionBuilder()
      .withUrl(`${baseURL}hubs/chat`, {
        accessTokenFactory: () => authToken,
        skipNegotiation: true,
        transport: HttpTransportType.WebSockets,
      })
      .withAutomaticReconnect()
      .build();
    connection.start().then(console.log).catch(console.error);

    setConnection(connection);
    return () => {
      connection.stop().catch(console.log);
    };
  }, []);

  useEffect(() => {
    if (connection && connection.on)
      connection.on("ReceiveMessage", (messages: MessageModel[]) => {
        dispatch(addEditMessages(messages));
      });
  }, [connection]);
};
